import { render, staticRenderFns } from "./MobileFeed.vue?vue&type=template&id=45dd45ac&scoped=true"
import script from "./MobileFeed.vue?vue&type=script&lang=js"
export * from "./MobileFeed.vue?vue&type=script&lang=js"
import style0 from "./MobileFeed.vue?vue&type=style&index=0&id=45dd45ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd45ac",
  null
  
)

export default component.exports